import React from "react";
import styled from "styled-components";

import EntityIcon from "../components/icons/Entity1";
import Button from "./IconButton";
import CommentIcon from "../components/icons/Comment/";
import LikeIcon from "./icons/Like";

const TweetContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  padding: 14px 16.3px;
  background-color: ${props => props.theme.backgroundTertiary};
  transition: background-color ease 1s;
  border-radius: 25px;
  text-align: right;
  margin: 22.5px;
  @media (min-width: 1800px) {
    padding: 22px 16.3px;
    margin: 0 45px 45px;
  }
  @media (max-width: 575px) {
    padding: 14px 17px;
  }
`;

const ActionButton = styled(Button)`
  height: 32px;
  @media (min-width: 1800px) {
    width: 100%;
    height: 40px;
  }
  @media (max-width: 575px) {
    height: 30px;
  }
`;

const Head = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const LogoCircle = styled.div`
  border-radius: 50%;
  width: 57.5px;
  height: 57.5px;
  background-color: ${props => props.theme.tweetLogoCircle};
  transition: background-color ease 1s;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (min-width: 1800px) {
    width: 70px;
    height: 70px;
  }
  @media (max-width: 575px) {
    width: 40px;
    height: 40px;
  }
`;

const DetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: right;
  margin-right: 10px;
`;

const Title = styled.span`
  font-family: "Dubai-bold";
  font-size: 14px;
  @media (min-width: 1800px) {
    font-size: 18px;
    line-height: 30px;
  }
  color: ${props => props.theme.text};
`;

const Date = styled.span`
  font-size: 10px;
  @media (min-width: 1800px) {
    font-size: 13px;
    line-height: 22px;
  }
  color: ${props => props.theme.text};
`;
const Tweet = styled.span`
  direction: rtl;
  font-size: 15px;
  line-height: 22px;
  color: ${props => props.theme.text};
  margin-top: 20px;
  @media (min-width: 1800px) {
    font-size: 18px;
    margin-bottom: 17px;
    line-height: 27px;
    margin-top: 28px;
  }
`;

const ActionsContainer = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  @media (max-width: 575px) {
    justify-content: flex-end;
  }
`;
const ButtonContainer = styled.div`
  width: 47%;
  @media (max-width: 575px) {
    width: 38%;
    margin-left: 15px;
  }
`;

const TweetBar = ({ onReplyClick, tweet, onLike }) => {
  return (
    <TweetContainer>
      <Head>
        <DetailContainer>
          <Title>{tweet.entityName}</Title>
          <Date>{tweet.date}</Date>
        </DetailContainer>
        <LogoCircle>
          <EntityIcon />
        </LogoCircle>
      </Head>
      <Tweet>{tweet.message} </Tweet>

      <ActionsContainer>
        <ButtonContainer>
          <ActionButton secondary onClick={onReplyClick}>
            <CommentIcon commented={!!tweet.comment} />
          </ActionButton>
        </ButtonContainer>
        <ButtonContainer>
          <ActionButton onClick={onLike}>
            <LikeIcon liked={tweet.isLiked} />
          </ActionButton>
        </ButtonContainer>
      </ActionsContainer>
    </TweetContainer>
  );
};

export default TweetBar;
